import { useDispatch, useSelector } from "react-redux";
import { toggleMenu } from "../../features/menu/menuSlice";

const SidebarToggle = () => {
  const dispatch = useDispatch();
  const open = useSelector((state) => state.menu.open);

  return (
    <button
      onClick={() => dispatch(toggleMenu())}
      className="p-2 text-white lg:hidden"
      aria-label={open ? "Menüyü kapat" : "Menüyü aç"}
    >
      {open ? (
        <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      ) : (
        <svg className="h-6 w-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      )}
    </button>
  );
};

export default SidebarToggle;
